export function config(name) {
	return process.env[`REACT_APP_${name}`];
}
